<div class="example-wrapper">
  @if (mode) {
    <div class="preview-tabs">
      @for (tab of tabs; track tab.value) {
        <button
          class="preview-tabs__tab"
          [class.preview-tabs__tab--active]="activeTab() === tab.value"
          (click)="activeTab.set(tab.value)">
          {{ tab.label }}
        </button>
      }
    </div>
  }

  <div class="surface" [class.surface--wide]="mode && !isMobile">
    @if (mode) {
      @switch (activeTab()) {
        @case ('info') {
          <ng-container *ngTemplateOutlet="infoContent"></ng-container>
        }
        @case ('order-summary') {
          <ng-container *ngTemplateOutlet="orderSummaryContent"></ng-container>
        }
        @case ('modal') {
          <multi-shipment-recipient-modal-preview
            [modal]="template?.addRecipientModal"></multi-shipment-recipient-modal-preview>
        }
      }
    } @else {
      <ng-container *ngTemplateOutlet="infoContent"></ng-container>
    }
  </div>
</div>

<ng-template #infoContent>
  <div class="info-block">
    <h4 class="section-label">Contact</h4>
    <s-polaris-text-field label="Email"></s-polaris-text-field>
    <s-polaris-banner [tone]="contactBannerTone">
      <span [innerHTML]="template?.contactSectionBanner?.text | safe: 'html'"></span>
    </s-polaris-banner>
  </div>

  <div class="info-block">
    <h4 class="section-label">Shipping to</h4>
    <multi-shipment-is-multi-picker-preview
      [shippingToggle]="template?.shippingToggle"
      [selection]="shippingMode()"
      (selectionChange)="shippingMode.set($event)"></multi-shipment-is-multi-picker-preview>

    @if (shippingMode() === 'multi' && recipientCount() === 0) {
      <multi-shipment-add-card-preview
        [card]="template?.recipientsBlock?.addRecipientCard"
        (actionPressed)="addRecipient()"></multi-shipment-add-card-preview>
    }
  </div>

  <div class="info-block">
    <h4 class="section-label">Delivery</h4>
    <s-polaris-banner [tone]="deliveryBannerTone">
      <span [innerHTML]="template?.deliverySectionBanner?.text | safe: 'html'"></span>
    </s-polaris-banner>
  </div>

  @if (shippingMode() === 'multi') {
    @if (recipientCount() > 0) {
      <div class="info-block">
        <h4 class="section-label">Recipients</h4>
        <multi-shipment-recipient-list-preview
          [recipientsBlock]="template?.recipientsBlock"
          [recipientCount]="recipientCount()"
          [isMobile]="isMobile"
          (recipientAdded)="addRecipient()"
          (recipientRemoved)="removeRecipient()"></multi-shipment-recipient-list-preview>
      </div>
    }
  } @else {
    <div class="info-block">
      <div class="gift-notes-heading">
        <h4 class="gift-notes-title">{{ template?.giftNotesBlock?.title }}</h4>
        <p class="gift-notes-description" [innerHTML]="template?.giftNotesBlock?.description | safe: 'html'"></p>
      </div>
      <multi-shipment-gift-notes-preview
        [giftNotesBlock]="template?.giftNotesBlock"
        [giftNoteCount]="giftNoteCount()"
        (giftNoteAdded)="addGiftNote()"
        (giftNoteRemoved)="removeGiftNote()"></multi-shipment-gift-notes-preview>
    </div>
  }
</ng-template>

<ng-template #orderSummaryContent>
  <multi-shipment-order-summary-preview
    [lineItemAssignmentStatus]="template?.lineItemAssignmentStatus"></multi-shipment-order-summary-preview>
</ng-template>
